export const DocumentValidationStatus = {
  Pending: 1,
  UserActionRequired: 5,
  Approved: 10,
  Unapproved: 20
}
